import { capitalize } from "@tomocredit/common-fe/utils/string";
import theme from '../../theme';
import { withBreakpoint } from './wrappers/withBreakpoint';

const SizeComponent = minSize => ({
  children,
  to: maxSize,
  breakpointContext: { isBetween },
}) => (isBetween(minSize, maxSize) ? children : null);

const SizeComponents = Object.keys(theme.screens).reduce(
  (acc, curr) => {
    acc[capitalize(curr)] = withBreakpoint(SizeComponent(curr));
    return acc;
  },
  { Xs: withBreakpoint(SizeComponent('xs')) },
);

export const {
  Xs, Sm, Md, Lg, Xl,
} = SizeComponents;
